import React from 'react';

const VS = ({ size = 1 }) => (
  <svg width={`${size}em`} viewBox="0 0 24.1 14.6" fill="none">
    <g transform="translate(-184 -765)">
      <path
        fill="currentColor"
        transform="translate(-18.9 345)"
        d="m217 420-5.22 13.8h-2.96l-5.23-13.8h3.08l3.65 10.4 3.65-10.4z"
      />
      <path
        fill="currentColor"
        transform="translate(-45.3 346)"
        d="m248 434c-2.63 0-4.59-0.9-5.34-2.57a4.62 4.62 0 0 1-0.059-3.49c0.647-1.41 2.22-2 4.02-2.49 1.67-0.451 3.22-0.706 3.63-1.59a1.68 1.68 0 0 0 0.1-0.627 1.38 1.38 0 0 0-0.117-0.628 2.11 2.11 0 0 0-2.04-0.981 2.07 2.07 0 0 0-2.08 1.08 2.97 2.97 0 0 0-0.215 1.24h-3a5.01 5.01 0 0 1 0.372-2.02c0.726-1.61 2.45-2.47 4.81-2.47 2.41 0 4.24 0.922 4.9 2.45a3.83 3.83 0 0 1 0.372 1.65 3.95 3.95 0 0 1-0.313 1.55c-0.569 1.28-1.96 1.92-3.57 2.35-1.69 0.49-3.38 0.745-3.84 1.78a1.65 1.65 0 0 0-0.157 0.726 1.88 1.88 0 0 0 0.177 0.765 2.97 2.97 0 0 0 4.61-0.157 3.15 3.15 0 0 0 0.216-1.28h3.2a5.42 5.42 0 0 1-0.412 2.1c-0.729 1.59-2.5 2.61-5.26 2.61z"
      />
    </g>
  </svg>
);

export default VS;
